<template>
	<div
		class="g-block-title-box-side-line g-block-title-padding"
		:class="{
			'g-block-title-box-side-line--edit': editable,
			'is-active': editable && active,
			'g-block-title-box-side-line--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-box-side-line__row">
			<span class="g-block-title-box-side-line__line" :style="{ background: lightColor }"></span>
			<div class="g-block-title-box-side-line__box" :style="{ background: themeColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-box-side-line__text"
					fit-content
					:model-value="data.content"
					placeholder="请输入标题"
					@update:model-value="onContentUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-box-side-line__text"
					v-html="data.content || ''"
				></div>
			</div>
			<span class="g-block-title-box-side-line__line" :style="{ background: lightColor }"></span>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleBoxSideLine',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-box-side-line {
		.title-block-edit-shell();
	}

	.g-block-title-box-side-line__row {
		display: flex;
		align-items: center;
		gap: 0;
	}

	.g-block-title-box-side-line__line {
		flex: 1;
		height: 1px;
		min-width: 16px;
	}

	.g-block-title-box-side-line__box {
		flex-shrink: 0;
		padding: 8px 20px;
		border-radius: 4px;
		max-width: calc(100% - 32px);
	}

	.g-block-title-box-side-line__text {
		font-size: 18px;
		font-weight: 700;
		line-height: 1.3;
		color: #fff;
		text-align: center;
		:deep(.g-rich-text-editable__content) {
			min-height: unset;
			padding: 0;
			font-weight: 700;
			color: inherit;
			text-align: center;
		}
	}

	.g-block-title-box-side-line--h5 {
		.g-block-title-box-side-line__box { padding: 0.16rem 0.4rem; border-radius: 0.08rem; max-width: calc(100% - 0.64rem); }
		.g-block-title-box-side-line__text { font-size: 0.36rem; }
		.g-block-title-box-side-line__line { height: 0.02rem; min-width: 0.32rem; }
	}
</style>
